@import "@zvuk-b2b/react-uikit/ui/styles/_mixins";

@import "src/application/layout/SmartLayout/_smart-layout-variables";

.SmartLayoutMenu {
    @include media-mobile {
        width: 0;
    }

    @include media-desktop {
        position: fixed;
        top: 0;
        width: $menu-desktop-width-collapsed;
        height: calc(var(--app-height) - var(--banner-height));
        z-index: $z-index-layer-l;
    }

    &Relative {
        position: relative;
        height: 100%;
    }

    &Container {
        display: flex;
        background-color: $color-white;

        @include media-mobile {
            position: fixed;
            z-index: $z-index-layer-l;
            top: calc(var(--banner-height) + #{$title-mobile-height});
            height: calc(var(--app-height) - var(--banner-height) - #{$title-mobile-height});
        }

        @include media-desktop {
            position: absolute;
            top: var(--banner-height);
            height: 100%;
        }
    }
}

.SmartLayout {
    display: grid;
    grid-template-columns: 1fr;
    background-color: $color-white;

    @include media-mobile {
        min-width: $mobile-width-xs;
    }

    @include media-desktop {
        min-width: calc($desktop-width-s - $menu-desktop-width-collapsed);
        margin-left: $menu-desktop-width-collapsed;
    }
}

.SmartLayoutHeader {
    position: fixed;
    top: 0;
    width: 100%;
    background-color: $color-white;

    @include media-mobile {
        z-index: $z-index-layer-s;
        min-width: $mobile-width-xs;
    }

    @include media-desktop {
        z-index: $z-index-layer-xl;
        min-width: $desktop-width-s;
    }

    &BannerContainer {
        width: 100%;
        height: fit-content;
        overflow: hidden;

        &[data-expanded=false] {
            max-height: 0;
            transition: max-height $transition-duration-m ease-in-out;
        }

        &[data-expanded=true] {
            @include media-mobile {
                max-height: 33.3vh;
            }

            @include media-desktop {
                max-height: 10vh;
            }

            transition: max-height $transition-duration-l ease-in-out;
        }
    }
}

.SmartLayoutMenuWithPlayer {
    padding-bottom: 50px;
}
